import gwt from '../../api/gwt';
import { mask } from 'vue-the-mask';
import moment from 'moment';
import { Constants } from './Constants';

// eslint-disable-next-line no-unused-vars
export default {
      directives: {
        mask
      },
    data () {
      return {
        constants: Constants,
        lastAdminCompany: -1,
        validationRules: {
          required: v => !!v || window.$vue.$t('wkt.admin.common.validation-utils.required_field'), //'Es necesario completar este campo',
          requiredBoolean: v => !(!v && v!==false) || 'Es necesario completar este campo',
          requiredMultiple: v => !!(v && v.length) || window.$vue.$t('wkt.admin.common.validation-utils.required_field'),
          emailRequired(v, email) { return (v===false || (v!==false && email && email.trim().length>0)) || window.$vue.$t('wkt.admin.common.validation-utils.email_required'); }, //'Es necesario completar el email',
          maxLength(v, maximum) { return (v || '').length <= maximum || 'El campo excede la longitud máxima permitida (' + maximum + ' caracteres)'; },
          rangeInt(v, minimum, maximum) { return ((v || '') >= minimum && (v || '') <= maximum) || window.$vue.$t('wkt.admin.common.validation-utils.required_field') + ' [ ' + minimum + ' - ' + maximum + ' ]'; },
          email: v => !v || /.+@.+\..+/.test(v) || window.$vue.$t('wkt.admin.common.validation-utils.invalid_field'),
          cifnif(v, country) { return (country ? gwt.validateCIFOrDNI(country.id, v) : false) || window.$vue.$t('wkt.admin.common.validation-utils.invalid_field'); },
					phone(v, country) { return (country ? gwt.validatePhone(country.id, v) : false) || window.$vue.$t('wkt.admin.common.validation-utils.invalid_field'); },
					cp(v, country) { return (country ? gwt.validatePostalCode(country.id, v) : false) || window.$vue.$t('wkt.admin.common.validation-utils.invalid_field'); },
					date: v => !v || this.validateDate(v) || 'No es una fecha válida dd/mm/aaaa',
          time: v => !v || this.validateTime(v) || 'No es una hora válida hh::mm:ss',
          decimalSeparator: (v) => {
            return !v || gwt.validateDecimalSeparator(v, window.navigator.userLanguage || window.navigator.language) || 'No es un número valido';
          },
          isValidRange: v => {
            const num = parseInt(v.toString().replace(',', '.').replace(/[^0-9.]/g, ''));
            return !isNaN(num) && num >= 0 && num <= 100 || 'El valor debe estar entre 0 y 100';
          },
        },
      }
    },
    computed: {
      uuid() {
        return this.$store.state.worktime.uuid;
      },
      deviceInfo() {
        return this.$store.state.worktime.deviceInfo;
      },
      turns() {
        return this.$store.state.worktime.turns;
      },
    },
    mounted: function() {
      var self = this;
      this.timeInterval = setInterval(self.updateTimeInterval, 1000);

      var locale = window.navigator.userLanguage || window.navigator.language;
      moment.locale(locale);
    },
    destroy: function() {
      clearInterval(this.timeInterval);
      this.timeInterval=null;
    },
    methods: {
      matchRole(profile,roles) {
        
        for (let role of roles) {
            let permissionName = 'module'+role;
            let permissionValue = -1;
            for (const [key] of Object.entries(profile)) {
                if (key.toLowerCase()===permissionName.toLocaleLowerCase()) {
                    permissionValue = profile[key];
                    break;
                }
            }

            if (permissionValue===1 || permissionValue===2) {
                return true;
            }
        }

        return false;
    },
    matchRoleModify(profile,roles) {
      
      for (let role of roles) {
          let permissionName = 'module'+role;
          let permissionValue = -1;
          for (const [key] of Object.entries(profile)) {
              if (key.toLowerCase()===permissionName.toLocaleLowerCase()) {
                  permissionValue = profile[key];
                  break;
              }
          }

          if (permissionValue===2) {
              return true;
          }
      }

      return false;
  },  
  checkLicenseTypeByModule(moduleId, licenseType) {
    let result = '';

    if (!moduleId) {
      return result;
    }

    moduleId = parseInt(moduleId);

    //comprobamos si el tipo de licencia debe ser CORPORATE
    switch (moduleId) {
      case 27: // EXPENSE_SHEET_CATEGORY
        if (licenseType !== 2) {
          result = 'C';
        }
    }

    //comprobamos si el tipo de licencia debe ser BUSINESS o CORPORATE
    switch (moduleId) {
      case 14: // ACTIVITY_TYPE 
      case 25: // EXPENSE_SHEET
        if (licenseType === 0) {
          result = 'BC';
        }      
    }

    return result;
  },
  disableLicenseTypeByModule(moduleId, licenseType) {
    let result = false;

    //comprobamos si el tipo de licencia debe ser CORPORATE
    switch (moduleId) {
      case 25: // EXPENSE_SHEET
      case 27: // EXPENSE_SHEET_CATEGORY
        if (licenseType !== 2) {
          result = true;
        }
    }

    //comprobamos si el tipo de licencia debe ser BUSINESS o CORPORATE
    switch (moduleId) {
      case 14: // ACTIVITY_TYPE 
        if (licenseType === 0) {
          result = true;
        }
    }

    return result;
  },
  isNotEnabledToEmployeesByModule(moduleId, company) {
    let result = false;

    if (!moduleId) {
      return result;
    }

    moduleId = parseInt(moduleId);

    switch (moduleId) {
      case 25: // EXPENSE_SHEET
        result = !company.moduleExpensesEnabled;
        break;
      case 28: // TELEWORK
        result = !company.moduleTeleworkEnabled;
        break;
    }

    return result;
  },
      ensureInitCompleted: function() { 
          if (!this.deviceInfo || !this.deviceInfo.enabled || !this.deviceInfo.registered)
          {
             this.$router.push({ name: 'init' });
             return false;
          }

          return true;
      },
      st: function(key) {
       if (key && key.indexOf && key.indexOf('wkt.')==0) {
        return this.$t(key);
       }
       return key;
      },
      updateTimeInterval: function() {
        this.currentTime = moment().format('LLLL');
     },
     getWeekdayNames() {
      return moment.weekdays();
     },
     getWeekdayAbbrFormString(initials) {
      if (!initials) return '';
      const weekdayInitials = initials.split(','); 
      const weekdaysMin = moment.weekdaysMin();
      let weekdays = [];
      weekdayInitials.forEach(i => {
        switch (i) {
          case 'L': weekdays.push(weekdaysMin[1]); break;
          case 'M': weekdays.push(weekdaysMin[2]); break;
          case 'X': weekdays.push(weekdaysMin[3]); break;
          case 'J': weekdays.push(weekdaysMin[4]); break;
          case 'V': weekdays.push(weekdaysMin[5]); break;
          case 'S': weekdays.push(weekdaysMin[6]); break;
          case 'D': weekdays.push(weekdaysMin[0]); break;
        }
      });
      return weekdays;
     },
     formatLocalDateToISOStringDate(date) {
      if (!date) return "";
      const iso = moment(date, 'L').toISOString(true);
      return iso.split('T')[0];
     },
     formatISOStringDateToLocalDate(date) {
       if (!date) return "";
       return moment(date).format('L');
     },
		formatOnlyDate(value) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit' });
		},
		formatFullDate(value) {
      if (!value) return "";
			var result = new Date(value).toLocaleString([this.$i18n.locale, 'en'], { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
			return result.charAt(0).toUpperCase() + result.slice(1);
		},
		formatLongDate(value) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit' });
		},
		formatShortDate(value) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: '2-digit', month: '2-digit', day: '2-digit' });
		},
		formatLongDateTime(value, is24hours) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: is24hours ? false: undefined });
		},
		formatShortDateTime(value, is24hours) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { year: '2-digit', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: is24hours ? false: undefined });
		},
		formatTime(value, is24hours) {
      if (!value) return "";
			return new Date(value).toLocaleString([this.$i18n.locale, 'en'], { hour: '2-digit', minute: '2-digit', hour12: is24hours ? false: undefined });
		},
    formatISODate(value) {
      if (!value) return "";
      return value.toISOString().split('T')[0];
    },
		validateJson(json) {
			try {
				JSON.parse(json);
				return true;
			} catch (e) {
				e;
			}
			return false;
		},
    mustRefresh() {
      let currentAdminCompany = gwt.getSessionProfile().companyId;
      let mustRefresh = this.lastAdminCompany>0 && this.lastAdminCompany !== currentAdminCompany;
      this.lastAdminCompany = currentAdminCompany;
      return mustRefresh;
    },
    getEmployeeFullname(employee) {
      if (!employee) {
        return '---';
      }
      return `${employee.lastname}, ${employee.firstname}`;
    },
    getProfileAssetUrl(fileName) {
      if (!fileName) {
        return "img/default-avatar.jpeg";
      }

      const bucketName = "worktime-dev"; // TODO: obtener de configuración
      return "https://storage.googleapis.com/" + bucketName + "/" + fileName;
    },
    getPubilcAssetUrl(fileName) {
      const bucketName = "worktime-dev"; // TODO: obtener de configuración
      return "https://storage.googleapis.com/" + bucketName + "/" + fileName;
    },
    getLongMonthName(month) {
      const date = new Date();
      date.setMonth(month - 1);
    
      return date.toLocaleString([this.$i18n.locale, 'en'], { month: 'long' });
    },
    getLongMonthNameWithYear(month, year) {
      return `${this.getLongMonthName(month)} ${year}`;
    },
    getCurrentYear() {
      return parseInt(moment().format('YYYY'));
    },
    getCurrentMonth() {
      return parseInt(moment().format('M'));
    },
    getCurrentWeek() {
      const numWeek = moment().endOf('week').isoWeek();
      return numWeek;
    },
    getNumOfWeeks(year) {
      const numWeeks = moment({ year: year }).isoWeeksInYear();
      return numWeeks;
    },
    getNumOfWeek(date, month, year) {
      let m = moment({ year: year, month: month - 1, date: date });
      const numWeek = m.isoWeek();
      return numWeek;
    },
    getFirstDayOfWeekIndex() {
      const date = moment().startOf('week').toDate();
      const index = date.getDay();
      return index;
    },
    getNumOfDaysInMonth(month, year) {
      return moment({ year: year, month: month - 1, date: 1 }).daysInMonth();
    },
    getFirstDayOfMonth(month, year) {
      let date = new Date(year, month - 1, 1);

      date.setHours(12);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    },
    getLastDayOfMonth(month, year) {
      let m = moment({ year: year, month: month - 1, date: 1 }).endOf('month');

      let date = m.toDate();
      date.setHours(12);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    },
    getFirstDayOfFirstWeekInYear(year) {
      let m = moment({ year: year });
      // Check if 1st of January is in the first week of the year
      if (m.week() !== 1) {
        // If not, add a week to the first day of the current week
        m.startOf('week').add(1, 'week');
      }

      let date = m.toDate();
      date.setHours(12);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    },
    getLastDayOfLastWeekInYear(year) {
      let m = moment({ year: year }).endOf('week').add(this.getNumOfWeeks(year) - 1, 'week');

      let date = m.toDate();
      date.setHours(12);
      date.setMinutes(0);
      date.setSeconds(0);

      return date;
    },
    getFirstDayOfWeek(week, year) {
      const date = this.getFirstDayOfFirstWeekInYear(year);
      const m = moment(date);
      m.add(week - 1, 'weeks').startOf('week');
      return m.toDate();
    },
    getLastDayOfWeek(week, year) {
      const date = this.getFirstDayOfFirstWeekInYear(year);
      const m = moment(date);
      m.add(week - 1, 'weeks').endOf('week');
      return m.toDate();
    },
    getWeekPeriod(week, year) {
      const firstDay = this.getFirstDayOfWeek(week, year);
      const lastDay = this.getLastDayOfWeek(week, year);

      const startPeriod = firstDay.getDate() + " " + this.getLongMonthName(parseInt(moment(firstDay).format('M')));
      const lastPeriod = lastDay.getDate() + " " + this.getLongMonthName(parseInt(moment(lastDay).format('M')));

      if (firstDay.getFullYear() != lastDay.getFullYear()) {
				return `${startPeriod} ${firstDay.getFullYear()} - ${lastPeriod} ${lastDay.getFullYear()}`;
			} else {
				return `${startPeriod} - ${lastPeriod} ${year}`;
			}
    },
    addDaysToDate(date, numDays) {
      return moment(date).add(numDays, 'days').toDate();
    },
    addMonthsToDate(date, numMonths) {
      return moment(date).add(numMonths, 'months').toDate();
    },
    convertSimpleDateToDate(date) {
      if (!date || !date.year || !date.month || !date.day) {
        return null;
      }
      return new Date(date.year, date.month - 1, date.day, 12, 0, 0);
    },
    convertDateToSimpleDate(date) {
      if (!date) {
        return null;
      }
      return { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() };
    },
    convertSimpleTimeToHHMM(time) {
      if (!time) {
        return null;
      }

      let date = new Date();
      date.setHours(time.hours);
      date.setMinutes(time.minutes);

      return moment(date).format('HH:mm');
    },
    convertTimeAsStringToSimpleTime(value) {
      if (!value || value.length != 5) {
        return null;
      }

      const time = {
        hours: parseInt(value.substring(0, 2)),
        minutes: parseInt(value.substring(3, 5)),
        seconds: 0
      };

      return time;
    },
    convertSimpleTimeAsDate(time) {
      if (!time) {
        return null;
      }
      
      let date = new Date();
      date.setHours(time.hours);
      date.setMinutes(time.minutes);
      date.setSeconds(time.seconds);

      return date;
    },
    convertDoubleToHHMM(value) {
      if (value === null) {
        return "0:00";
      }

      const sign = value < 0 ? '-' : '';

      // pasamos horas a minutos y redondeamos (evita fallos de redondeo)
      let minutes = Math.round(Math.abs(value) * 60);
      const hours = Math.floor(minutes / 60);
      minutes -= hours * 60;

      return `${sign}${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    },
    parseHHMMToDouble(time) {
      const hours = parseFloat(time.split(':')[0]);
      const minutes = parseFloat(time.split(':')[1]);

      if (isNaN(hours) || isNaN(minutes)) {
        return null;
      }
        
      return hours + minutes / 60.0;
    },
    convertSimpleTimeToMs(time){
      return time.hours * 60 * 60 + time.minutes * 60 + time.seconds * 1000;
    },
    compareSimpleTimes(time1, time2) {
      const msTime1 = this.convertSimpleTimeToMs(time1);
      const msTime2 = this.convertSimpleTimeToMs(time2);
      const diff = msTime1 - msTime2; 
 
      return diff < 0 ? -1 : (diff > 1 ? 1 : 0);
    },
    getAbsoluteHoursDifference(fromTime, toTime) {
      if (!fromTime || !toTime) return 0;
      
      let mdiff = 0;

      if (this.compareSimpleTimes(toTime, fromTime) === -1) {
        const fromDate = this.convertSimpleTimeAsDate(fromTime);
        const toDate = this.convertSimpleTimeAsDate(toTime);

        toDate.setDate(toDate.getDate() + 1);
  
        mdiff = toDate.getTime() - fromDate.getTime();
      } else {
        const fromDate = this.convertSimpleTimeAsDate(fromTime);
        const toDate = this.convertSimpleTimeAsDate(toTime);

        mdiff = toDate.getTime() - fromDate.getTime();
      }
         
      return mdiff / (60*60*1000);
    },
    isToday(date) {
      if (date === null) {
        return false;
      }
      
      const today = new Date();
      
      if (date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear()) {
        return true;
      }
  
      return false;
    },
    compareSimpleDates(date1, date2) {
      if (date1 === null && date2 === null) {
        return 0;
      }
      if (date1 !== null && date2 === null) {
        return -1;
      }
      if (date1 === null && date2 !== null) {
        return 1;
      }
      
      const dt1 = this.convertSimpleDateToDate(date1);
      const dt2 = this.convertSimpleDateToDate(date2);

      const diff = dt1 - dt2;
  
      return diff;
    },
    getTimeAsDate(time) {
      if (!time) return ''; 
      const [hours, minutes] = time.split(':');
      let toDate = new Date();
      toDate.setHours(hours);
      toDate.setMinutes(minutes);
      toDate.setSeconds(0);
      toDate.setTime(toDate.getTime() - toDate.getTimezoneOffset() * 60 * 1000);

      return toDate;
    },  
    getHoursMins(time) {
      if (!time) return ''; 
      const date = this.getTimeAsDate(time);     
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    },
		convertColorToHex(color) {
			if (!color) {
				return null;
			}

      const colorParts = color.split(' ');

      let colorId = colorParts[0].replace('-', '').toUpperCase();

			if (colorParts.length == 2) {
				colorId += `-${colorParts[1].toUpperCase()}`;
			}

			const index = Constants.COLORS.findIndex(c => c.id === colorId);

			if (index === -1) {
				return color;
			}

      return Constants.COLORS[index].hex;
    },
    getEntityIdsFromStringIds(entityIds) {
      if (entityIds == null) {
        return null;
      }
  
      const ids = entityIds.split(',');
  
      let items = [];
      for (let i = 0; i < ids.length; i++) {
        this.ids.push(Number(ids[i]));
     }
  
      return items.length === 0 ? null : items;
    },
    isSessionEmployeeSuperAdmin() {
      if (!gwt.getSessionInformation()) {
        return false;
      }
  
      return gwt.getSessionInformation().employee.isSuperAdmin;
    },
    isEmulationEnabled() {
      if (!gwt.getSessionInformation() || !gwt.getSessionInformation().company) {
          return false;
      }

			const isSessionEmployeeSuperAdmin = gwt.getSessionInformation().employee.isSuperAdmin;
			const sessionEmployeeCompanyId = gwt.getSessionInformation().employee.companyId;
			const sessionCompanyId = gwt.getSessionInformation().company.id;
			
			return isSessionEmployeeSuperAdmin && sessionEmployeeCompanyId !== sessionCompanyId;
    },
    getWorkplaceNamesFromStringIds(workplaceIds) {    
      if (workplaceIds === null) {
          return this.$t('wkt.admin.elements.access-type-element.all_workplaces');
      }
  
      const workplaces = gwt.getWorkplaces();
  
      if (workplaces === null || workplaces.length === 0) {
          return null;
      }
  
      const ids = workplaceIds.split(",");
      const items = [];
  
      for (const id of ids) {
          const workplaceId = Number(id.trim());
  
          const workplace = workplaces.find(x => x.id === workplaceId);
  
          if (workplace !== undefined && workplace !== null) {
              items.push(workplace.name);
          }
      }
  
      return items.length === 0 ? null : items.join(", ");
    },
    getWorkplaceNameById(workplaceId) {
      if (!workplaceId) {
        return this.$t('wkt.admin.elements.access-type-element.all_workplaces');
      }

      const workplaces = gwt.getWorkplaces();

      if (!workplaces || workplaces.length === 0) {
          return null;
      }

      const workplace = workplaces.find(x=> x.id === workplaceId);

      return workplace ? workplace.name : null;
    },
    getDepartmentNamesFromStringIds(departmentIds) {
      if (departmentIds === null) {
          return this.$t('wkt.admin.elements.access-type-element.all_departments');
      }

      const departments = gwt.getDepartments();
      if (departments === null || departments.length === 0) {
          return null;
      }

      const ids = departmentIds.split(",");
      const items = [];

      for (const id of ids) {
          const departmentId = Number(id.trim());
          const department = departments.find(x => x.id === departmentId);
          if (department !== undefined && department !== null) {
              items.push(department.name);
          }
      }

      return items.length === 0 ? null : items.join(", ");
    },
    getProjectNamesFromStringIds(projectIds) {
      if (projectIds === null) {
          return this.$t('wkt.admin.elements.access-type-element.all_projects');
      }

      const projects = gwt.getProjects();
      if (projects === null || projects.length === 0) {
          return null;
      }

      const ids = projectIds.split(",");
      const items = [];

      for (const id of ids) {
          const projectId = Number(id.trim());
          const project = projects.find(x => x.id === projectId);
          if (project !== undefined && project !== null) {
              items.push(project.shortName);
          }
      }

      return items.length === 0 ? null : items.join(", ");
    },
    getEmployeeFullName(employee) {
      if (employee === null) {
        return "---";
      }
  
      return `${employee.lastname}, ${employee.firstname}`;
    },
    getEmployeeNamesFromStringIds(employeeIds) {
      if (employeeIds === null) {
          return this.$t('wkt.admin.procedures.select_all_employees');
      }
  
      const departments =  gwt.getDepartments();
  
      if (departments === null || departments.length === 0) {
          return null;
      }
  
      const ids = employeeIds.split(",");
      const items = [];
  
      for (const id of ids) {
          if (id === null || id.trim() === "") {
              continue;
          }
  
          const employeeId = parseInt(id.trim());
  
          for (const department of departments) {
              for (const employee of department.employees) {
                  if (employee.id === employeeId) {
                      items.push(this.getEmployeeFullName(employee));
                  }
              }
          }
      }
  
      return items.length === 0 ? null : items.join(" | ");
    }
  },
}